module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "id": "con"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/dw.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": ".5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/07_introduction#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/08_chapter01#c1"
    }
  }, [_vm._v("1. The Purposes and Methodologies of Black Magick")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/09_chapter02#c2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. H. P. Lovecraft: Prophet of the Aeon of the Great Old Ones")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter03#c3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Spurious Necronomicons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter04#c4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. The Simon/Schlangekraft Necronomicon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter05#c5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. The Great Old Ones")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter06#c6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Lovecraft and the Afro-Haitian Vodou Cults")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter07#c7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Lovecraft and the Wiccan Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter08#c8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. Lovecraft and the Typhonian O.T.O.")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter09#c9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. Lovecraft and the Church of Satan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter10#c10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. Lovecraft and the Chaos Magick Pacts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter11#c11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/19_notes#note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/20_index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-350067dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_contents.vue
// module id = 69
// module chunks = 0